module.exports = __webpack_public_path__ + "images/help/icn-faq-howto@2x-461938a8c2f5ca03fd2183ee9c59dcb1.png";